export default {
    book_now: 'Reservar ahora',
    minimum_age: 'Solo mayores de {age} años',
    excess_liability: 'Extensión de responsabilidad civil',
    security_deposit: 'Depósito de seguridad',
    fuel_policy: 'Política de repostaje',
    like_for_like: 'Equivalente',
    full_to_full: 'Devolución del depósito lleno',
    miles_per_rental: '{mileage} millas gratis por alquiler',
    km_per_rental: '{mileage} km gratis por alquiler',
    unlimited_mileage: 'Millas ilimitada',
    unlimited_mileage_km: 'Km ilimitados',
    non_amendable: 'No modificable',
    non_refundable: 'No reembolsable',
    free_cancellation_until: 'Cancelación gratuita hasta las',
    cancellation_in_line_with: 'Cancelación acorde con',
    tcs: 'los términos y condiciones',
    free_extras_on_collection: 'Dos extras gratis durante la recogida',
    glass_and_tyres_covered: 'Lunas y neumáticos cubiertos',
    number_of_passengers: 'Número de pasajeros',
    number_of_bags: 'Número de bultos',
    fuel_type: 'Tipo de combustible',
    co2: 'CO2',
    aircon: 'Aire acondicionado',
    transmission: 'Transmisión',
    book_type: 'Reservar {type}',
    debit_card_deposit: 'Tarjeta de débito aceptada para depósitos',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/es/quotes/price_card.js